// removed by extract-text-webpack-plugin
module.exports = {"legendLabelWrapper":"legend-module__legendLabelWrapper___34Kzd","legendWrapper":"legend-module__legendWrapper___GqWIs","legendItem":"legend-module__legendItem___zyqkF","legendLabelItem":"legend-module__legendLabelItem___UrZoC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/legend/legend.module.scss
// module id = 2105
// module chunks = 0